<template>
  <div>
    <app-header></app-header>
    <div class="container-fluid" style="background-color: white;">
      <div class="display-4">Cilinder 880 - sleutelbediend</div>
      <hr>
    </div>

    <div class="container-fluid">
      <div class="row">
        <img class="centered-and-cropped mb-2 col-2" src="/src/assets/880cyl.PNG">
        <div class="col-4"></div>
        <div class="col-6">
          <h2>Bestellijst</h2><button class="btn btn-primary" @click="reset">Reset</button>
          <div class="row">
            <span class="col-1"><strong></strong></span>
            <span class="col-4"><strong>Art.Nummer</strong></span>
            <span class="col-2"><strong>Aantal</strong></span>
          </div>
          <div v-for="w in winkelmand" v-bind:key="w.id" class="row">
            <span class="col-1"><strong>{{w.id}}</strong></span>
            <span class="col-4">{{w.artnummer}}</span>
            <span class="col-2">{{w.aantal}}</span>
          </div>
          <div v-if="winkelmand.length > 1" class="form-group form-check mt-5">
            <input type="checkbox" v-model="gs" @click="setgs" class="form-check-input" id="exampleCheck1">
            <label class="form-check-label" for="exampleCheck1">Onderling gelijksluitend?</label>
          </div>
        </div>
      </div>
      <h1 class="col-4"><strong>880-{{bdim}}-{{cdim}}</strong></h1>
      <div class="row mt-5">
        <p class="form-text mb-1 col-1" style="text-align: center">
          B
        </p>
        <select class="form-control form-control-sm v-step-12 col-1" v-model="bdim">
          <option v-for="b in cyl880b" v-bind:key="b">{{b}}</option>
        </select>
        <p class="form-text mb-1 col-1" style="text-align: center">
          C
        </p>
        <select class="form-control form-control-sm v-step-12 col-1" v-model="cdim">
          <option v-for="c in cyl880c" v-bind:key="c.c">{{c.c}}</option>
        </select>
        <p class="form-text mb-1 col-1" style="text-align: center">
          Aantal
        </p>
        <input type="number" min="1" class="form-control form-control-sm v-step-12 col-1 mr-3" v-model="aantal">
        <button class="btn btn-sm btn-primary" @click="verzend">Verzenden</button>
      </div>
    </div>
    <svg class="my-5" width="400" :height="200">
      <!-- Frame -->
      <polygon points="35,35 177,35 177,90 213,90 213,35 365,35 365,120 35,120 35,35" style="fill:none;stroke:black;stroke-width:2" />
      <polygon points="180,10 210,10 210,87 180,87 180,10" style="fill:grey;stroke:black;stroke-width:2" />
      <line x1="180" y1="37" x2 ="210" y2="37" stroke="black" stroke-width="2" />
      <circle cx="195" cy="110" r="5" stroke="black" stroke-width="1" fill="white" />
      <line x1="35" y1="100" x2 ="365" y2="100" stroke="black" stroke-width=".5" />
      <line x1="195" y1="7" x2 ="195" y2="123" stroke="black" stroke-width=".25" stroke-dasharray="8 1 .2 1" />
      <line x1="35" y1="100" x2 ="40" y2="101" stroke="black" stroke-width=".5" />
      <line x1="35" y1="100" x2 ="40" y2="99" stroke="black" stroke-width=".5" />
      <polygon points="35,100 40,101 40,99 35,100" style="fill:black;stroke:black;stroke-width:.5" />
      <polygon points="365,100 360,101 360,99 365,100" style="fill:black;stroke:black;stroke-width:.5" />
      <polygon points="195,100 200,101 200,99 195,100" style="fill:black;stroke:black;stroke-width:.5" />
      <polygon points="195,100 190,101 190,99 195,100" style="fill:black;stroke:black;stroke-width:.5" />
      <text style="text-anchor: middle; fill: blue; font-weight:bold;" x="100" y="95" font-size="20">B</text>
      <text style="text-anchor: middle; fill: blue; font-weight:bold;" x="290" y="95" font-size="20">C</text>
      <foreignObject x="50" y="50" width="110px" height="40px">
          <select style="width:100px" v-model="bdim">
            <option  v-for="b in cyl880b" v-bind:key="b">{{b}}</option>
          </select>
      </foreignObject>
      <foreignObject x="245" y="50" width="100px" height="40px">
          <select style="width:100px" v-model="bdim">
            <option  v-for="c in cyl880c" v-bind:key="c.c">{{c.c}}</option>
          </select>
      </foreignObject>
    </svg>
    
  </div>
</template>

<script>
import AppHeader from "../intro/AppHeader";
import store from '../../ClientApp/store';
import projectsteps from '../../ClientApp/helpers/project-steps';

export default {
  data(){
    return {
      id:1,
      bdim: 30,
      cdim: 30,
      aantal: 1,
      winkelmand: [],
      gs: false
    }
  },
  computed: {
    cyl880b(){
      var bvalues = this.$store.getters.getcyl880b;
      return bvalues ;
    },
    cyl880c(){
      var cylvalues = this.$store.getters.getcyl880;
      var cvalues = cylvalues.filter(a => a.b == this.bdim)
      console.log(cvalues);
      if(!cvalues.find(a => a.c == this.cdim)) this.cdim = cvalues[0].c;
      return cvalues ;
    }
  },
  methods: {
    verzend(){
      if (this.aantal != 0){
      if (this.gs == false)
        this.winkelmand.push({id: this.id, artnummer: '880-'+this.bdim+"-"+this.cdim, bdim: this.bdim, cdim: this.cdim, aantal: this.aantal})
      if (this.gs == true)
        this.winkelmand.push({id: this.id, artnummer: '880A-'+this.bdim+"-"+this.cdim, bdim: this.bdim, cdim: this.cdim, aantal: this.aantal})
      this.id++;
      }
    },
    reset(){
      this.winkelmand = [];
      this.gs = false;
    },
    setgs(){
      console.log("gs: " + this.gs)
      this.gs = !this.gs;
      if (this.gs == true){
        this.winkelmand.forEach(b => 
          b.artnummer = '880A-'+b.bdim + '-' + b.cdim)
      } else{
        this.winkelmand.forEach(b => 
          b.artnummer = '880-'+b.bdim + '-' + b.cdim)
      }

    }
  }
}
</script>

<style scoped>
    @media (min-width: 1500px) {
        .container-fluid {
        width: 80%;
        }
    }
    @media (min-width: 2000px) {
        .container-fluid {
        width: 60%;
        }
    }
    .lnk{
      cursor:pointer;
    }

    .centered-and-cropped { object-fit: contain }
    
</style>


// WEBPACK FOOTER //
// src/components/cilinders/Config880.vue